function Footer() {
  return (
    <footer className="fixed bottom-0 flex text-center border-t border-gray-200 justify-center items-center h-14 w-screen bg-[#B3E5FC] bg-opacity-80">
      <p className="text-md text-black">Copyright 2024 by Travel Journal</p>
    </footer>
  );
}

export default Footer;